import customParseFormat from 'dayjs/plugin/customParseFormat';
import styled from 'styled-components';
import _ from 'lodash';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { INVOICE_DIRECTIONS, REQUEST_LEDGERS, REQUEST_VAT_CODES } from '../../Invoices/constants';
import { BaseComponent } from '../../../components/BaseComponent';
import { Content } from '../../../components/Content';
import { FormField } from '../../../components/FormFields';
import { HBox, VBox } from '../../../components/Box';
import { selectCompany, selectLedgers, selectVatCodes } from '../../Invoices/selectors';
import { createProduct, fetchProduct, getCounters, setNewProductValue, updateProduct } from '../actions';
import { selectConfig, selectWork, selectWorks } from '../../Api/selectors';
import { getLedgers, getVatCodes } from '../../Invoices/actions';
import { mapProduct } from '../reducer';
import { PageHeader } from '../../../components/PageHeader';
import { ChevronRight, Left } from '../../../components/Icon';
import { SearchSelect } from '../../../components/SearchSelectComponent';
import { Loader } from '../../../components/Loader';
import { REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA, REQUEST_GET_COUNTERS, REQUEST_UPDATE_PRODUCT } from '../constants';
import { selectVehicleCounters } from '../selectors';
import { CompanySpecificField } from '../components/CompanySpecificField';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { fixPriceFormat, getQuantOfDecimalPlaces } from '../../../utils/string';
import { ProductCustomFinDataSection } from '../components/ProductCustomFinDataSection';
import TaxRegionsTab from '../components/TaxRegionsTab';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';

import styles from './create.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { ProductTasksSection } from '../components/ProductTasksSection';
import { formatToTwoDecimalPlaces, isValidNumber, limitToTwoDecimalPlaces } from '../../../utils/number';

dayjs.extend(customParseFormat);

const Container = styled.div`
  .nav-link {
    cursor: pointer;
  }
  .nav-link.active {
    color: blue;
  }

  .col {
    width: 100%;
  }
  .col-main {
    padding-right: 48px;
  }

  .basic-multi-select {
    width: 100%;
  }
  .formField {
    margin-bottom: 12px;
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .field-block {
    width: 50%;
  }
  .info-card {
    padding: 24px;
    width: auto;
    h2 {
      margin-bottom: 24px;
    }
    .btn {
      margin-right: 6px;
    }
    .col {
      @media (max-width: 768px) {
        width: 100%;
        min-width: 200px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

const BOOLEAN_OPTIONS = [
  { label: 'true', value: true },
  { label: 'false', value: false },
];

const ModalContentWrapper = styled.div`
  height: 300px;
`;

const STATE = {
  customFinData: {},
};

/* eslint-disable react/prefer-stateless-function */
class ProductCreateComp extends BaseComponent {
  constructor(props) {
    super(props, { ..._.cloneDeep(STATE) });
  }

  componentDidMount() {
    this.props.getVatCodes();
    this.props.getCounters(res => console.log(res, 'RES_COUNTERS'));
    this.props.getLedgers();
    if (this.props.id)
      return this.props.fetch(result => {
        if (result.id) {
          const parsedProduct = { ...mapProduct(result) };
          const formatSalesPriceExclVat = isValidNumber(parsedProduct?.salesPriceExclVat)
            ? parseFloat(parsedProduct?.salesPriceExclVat).toFixed(2)
            : null;
          const formatPurchasePriceExclVat = isValidNumber(parsedProduct?.purchasePriceExclVat)
            ? parseFloat(parsedProduct?.purchasePriceExclVat).toFixed(2)
            : null;
          if (formatSalesPriceExclVat) {
            parsedProduct.salesPriceExclVatToShow = formatSalesPriceExclVat;
            parsedProduct.purchasePriceExclVatToShow = formatPurchasePriceExclVat;
          }
          this.setState(parsedProduct);
        }
      });
  }

  get product() {
    if (!this.state.id) return null;

    return { ...this.state };
  }

  get dto() {
    const customFinData = Object.values(this.state.customFinData).reduce((prev, curr) => {
      curr.taxRegion !== this.defaultRegion &&
        prev.push({
          ...curr,
          purchasePrice: +curr.purchasePrice,
          salesPrice: +curr.salesPrice,
        });
      return prev;
    }, []);

    return {
      name: this.state.name,
      description: this.state.description,
      purchasePrice: +this.state.purchasePrice,
      purchasePriceExclVat: +this.state.purchasePriceExclVat,
      salesPrice: +this.state.salesPrice,
      // salesPrice: 3.390000104904175,
      // salesPriceExclVat: 2.799999952316284,
      salesPriceExclVat: +this.state.salesPriceExclVat,
      ledgerIn: this.state.ledgerIn,
      ledgerOut: this.state.ledgerOut,
      vatIn: this.state.vatIn,
      vatOut: this.state.vatOut,
      vehiclePurposeType: this.state.vehiclePurposeType,
      isOneTime: this.state.isOneTime === undefined ? '0' : this.state.isOneTime,
      isCounter: this.state.isCounter === undefined ? '0' : this.state.isCounter,
      status: this.state.status,
      counter: this.state.counter ?? null,
      isTransport: this.state.isTransport === undefined ? '0' : this.state.isTransport,
      customFinData,
    };
  }

  get counterOptions() {
    return this.props.counters?.map(c => ({
      label: c,
      value: c,
    }));
  }

  vehiclePurposeOptions() {
    return ['passenger', 'commercial'].map(p => {
      const lbl = `vehicle.filter.${p.toLowerCase()}`;
      return { value: p, label: lbl };
    });
  }

  get statusOption() {
    return ['0', '1', '2'].map(p => {
      const lbl = this.lbl(`product.column.status.${p.toLowerCase()}`);
      return { value: p, label: lbl };
    });
  }

  get defaultRegion() {
    return 'default';
  }

  get taxRegion() {
    return this.state.taxRegion ?? this.defaultRegion;
  }

  get availableNewTaxRegionOptions() {
    const regions = this.props.config.taxRegions.filter(r => !Object.keys(this.state?.customFinData).includes(r));

    return regions.map(r => ({ value: r, label: r }));
  }

  get addedRegions() {
    return [{ ...this.state, taxRegion: this.defaultRegion }, ...Object.values(this.state?.customFinData)];
  }

  setTaxRegion = e => {
    const { value } = e;
    this.setState({
      taxRegion: value,
    });
  };

  setSelectedNewTaxRegion = e => {
    const { value } = e;
    this.setState({
      selectedNewTaxRegion: value,
    });
  };

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get ledgers() {
    return this.props.ledgers ?? [];
  }

  reset() {
    this.setState(prev => ({ ...STATE }));
    this.to('/products');
  }

  value(valueName) {
    if (this.state[valueName] !== undefined) return this.state[valueName];
  }

  onStringInputChange(evt) {
    this.updateState(evt.target.name, evt.target.value);
  }

  updateStateWithCallback(prop, value, callback = null) {
    if (_.isObject(prop) && value === undefined) {
      this.setState({ ...(this.state || {}), ...prop }, callback);
      return this;
    }

    let state = this.state || {};
    this.setState(
      { ...state, [prop]: value, [`${prop}ToShow`]: isValidNumber(value) ? parseFloat(value)?.toFixed(2) : '0.00' },
      callback,
    );
    return this;
  }

  onNumberInputChange(evt) {
    if (evt.persist) {
      evt.persist();
    }
    const value = evt?.target.value || '';
    // if (getQuantOfDecimalPlaces(value) > 2) return;
    this.setState({
      [evt.target.name]: value,
      [`${evt.target.name}ToShow`]: value,
    });
    if (value) {
      this._t = this.timeout(() => this.onSetFixedValue(evt?.target.name, value), 2500, this._t);
    }

    return;
  }

  onPriceInclVatChanged(dto, taxRegion) {
    const direction = dto.name === 'salesPrice' ? INVOICE_DIRECTIONS.OUTGOING : INVOICE_DIRECTIONS.INCOMING;
    if (taxRegion === 'default') {
      this.setState({ [dto.name]: dto.value }, () => {
        const data = this.getCustomDataForTaxRegion(taxRegion);
        const exclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';
        const inclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePrice' : 'salesPrice';
        const vatKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'vatIn' : 'vatOut';
        const vatCode = data[vatKey] ?? null;
        const vatObj = this.props.vatCodes.find(v => v.code === vatCode) ?? { percentage: 0 };
        const inclVatPrice = this.formatString(data[inclPriceKey]) || 0;
        const exclVatPrice = inclVatPrice / (1 + vatObj.percentage);

        this.onNumberInputChange({ target: { name: exclPriceKey, value: String(exclVatPrice) } });
      });
    } else {
      this.setState(
        prev => ({
          customFinData: {
            ...prev.customFinData,
            [taxRegion]: {
              ...prev.customFinData[taxRegion],
              [dto.name]: dto.value,
            },
          },
        }),
        () => {
          const data = this.getCustomDataForTaxRegion(taxRegion);
          const exclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';
          const inclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePrice' : 'salesPrice';
          const vatKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'vatIn' : 'vatOut';
          const vatCode = data[vatKey] ?? null;
          const vatObj = this.props.vatCodes.find(v => v.code === vatCode) ?? { percentage: 0 };
          const inclVatPrice = this.formatString(data[inclPriceKey]) || 0;
          const exclVatPrice = inclVatPrice / (1 + vatObj.percentage);

          this.onNumberInputChange({ target: { name: exclPriceKey, value: String(exclVatPrice) } });
        },
      );
    }
  }

  onSetFixedValue(name, value) {
    const roundValue = value ? parseFloat(value?.replace(',', '.')) : value;
    this.updateStateWithCallback(name, fixPriceFormat(roundValue, 30), () => {
      this.initRecalculationOnField(name);
    });
  }

  formatString(string) {
    const replacedCommas = string?.toString()?.replace(',', '.');
    return parseFloat(replacedCommas);
  }

  getRecalculatedDataForTaxRegion(direction, taxRegion) {
    const exclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePriceExclVat' : 'salesPriceExclVat';
    const inclPriceKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'purchasePrice' : 'salesPrice';
    const vatKey = direction === INVOICE_DIRECTIONS.INCOMING ? 'vatIn' : 'vatOut';
    const data = this.getCustomDataForTaxRegion(taxRegion);

    let exclPrice = this.formatString(this.state[exclPriceKey]) || 0;
    let vatCode = data[vatKey] ?? null;
    let vatObj = this.props.vatCodes.find(v => v.code === vatCode) ?? { percentage: 0 };

    // data[inclPriceKey] = fixPriceFormat(_.round(+exclPrice * (1 + vatObj.percentage), 2));
    // TODO-rounding
    data[inclPriceKey] = +exclPrice * (1 + vatObj.percentage);

    return data;
  }

  setRecalculatedDataForTaxRegion(data, taxRegion) {
    if (taxRegion === this.defaultRegion) {
      this.setState(
        state => ({ ...data }),
        () => this.setState({ saveDisable: false }),
      );
      return;
    }

    this.setState(
      state => ({
        customFinData: {
          ...state.customFinData,
          [taxRegion]: data,
        },
      }),
      () => this.setState({ saveDisable: false }),
    );
  }

  setRecalculatedDataForAllRegions(data) {
    this.setState(
      state => ({ ...data }),
      () => this.setState({ saveDisable: false }),
    );
  }

  initRecalculationOnField(field, taxRegion) {
    this.setState({ saveDisable: true });

    if (['purchasePriceExclVat', 'salesPriceExclVat'].includes(field)) {
      const direction = field === 'purchasePriceExclVat' ? INVOICE_DIRECTIONS.INCOMING : INVOICE_DIRECTIONS.OUTGOING;
      const defaultDataRegion = { ...this.getRecalculatedDataForTaxRegion(direction, this.defaultRegion), dirty: true };
      const customFinData = Object.keys(this.state.customFinData).reduce((prev, curr) => {
        prev[curr] = { ...this.getRecalculatedDataForTaxRegion(direction, curr), dirty: true };
        return prev;
      }, {});
      const data = { ...defaultDataRegion, customFinData };
      delete data.taxRegion;
      this.setRecalculatedDataForAllRegions(data);
    } else {
      const direction = ['vatIn'].includes(field) ? INVOICE_DIRECTIONS.INCOMING : INVOICE_DIRECTIONS.OUTGOING;
      const data = this.getRecalculatedDataForTaxRegion(direction, taxRegion);
      this.setRecalculatedDataForTaxRegion(data, taxRegion);
    }
  }

  onCustomFieldChanged(dto, taxRegion) {
    if (['purchasePrice', 'salesPrice'].includes(dto.name)) {
      this.onPriceInclVatChanged(dto, taxRegion);
      return;
    }

    const callback = ['purchasePriceExclVat', 'salesPriceExclVat', 'vatIn', 'vatOut'].includes(dto.name)
      ? () => this.initRecalculationOnField(dto.name, taxRegion)
      : null;
    if (taxRegion === this.defaultRegion) {
      this.setState({ [dto.name]: dto.value, dirty: true }, callback);
    } else {
      this.setState(
        state => ({
          customFinData: {
            ...state.customFinData,
            [taxRegion]: { ...state.customFinData[taxRegion], [dto.name]: dto.value, dirty: true },
          },
        }),
        callback,
      );
    }
  }

  setVehiclePurposeType = e => {
    const { value } = e;
    this.setState({
      vehiclePurposeType: value,
    });
  };

  setVehicleCounter = e => {
    const { value } = e;
    this.setState({
      counter: value,
    });
  };

  setStatus = e => {
    const { value } = e;
    this.setState({
      status: value,
    });
  };

  setIsOneTime = value => {
    this.setState({
      isOneTime: value == '0' ? null : '1',
    });
  };

  setIsCounter = value => {
    this.setState(prev => {
      return {
        isCounter: value == '0' ? null : '1',
        counter: value == '0' ? null : prev.counter,
      };
    });
  };

  setIsTransport = value => {
    this.setState({
      isTransport: value == '0' ? null : '1',
    });
  };

  onStringInputChange1(event) {
    const inputValue = event.target.value;

    if (inputValue.length <= 60) {
      this.setState({ name: inputValue });
    } else {
      alert('Het maximale aantal karakters van 60 is bereikt.');
    }
  }

  onComplete() {
    if (this.props.id) {
      return this.props.update(this.dto, result => {
        if (result.id) {
          this.reset();
          this.to(`/products`);
        }
      });
    }
    return this.props.create(this.dto, result => {
      this.reset();

      if (result.id) this.to(`/products/${result?.id}`);
    });
  }

  get completeDisabled() {
    const nameFilled = this.state.name;

    let purchaseDataFilledCorrectly =
      this.state.vatIn && this.state.ledgerIn && (this.state.purchasePrice || this.state.purchasePrice == 0);

    let salesDataFilledCorrectly = this.state.vatOut && this.state.ledgerOut && this.state.salesPrice;

    let filledAtLeastOneDirectionData = purchaseDataFilledCorrectly || salesDataFilledCorrectly;

    const dataFilledCorrectly =
      nameFilled && filledAtLeastOneDirectionData && (this.state.isOneTime || this.state.isCounter);

    return !dataFilledCorrectly;
  }

  get saveButtonLabel() {
    const label = this.props.id ? this.lbl('product.create.updateBtn') : this.lbl('product.create.createBtn');
    return this.state.saveDisable ? this.lbl('calculating_progreess') : label;
  }

  getCustomDataForTaxRegion(taxRegion) {
    if (taxRegion === this.defaultRegion) {
      return {
        taxRegion,
        purchasePrice: this.state.purchasePrice,
        vatIn: this.state.vatIn,
        ledgerIn: this.state.ledgerIn,
        salesPrice: this.state.salesPrice,
        vatOut: this.state.vatOut,
        ledgerOut: this.state.ledgerOut,
      };
    }

    return this.state.customFinData[taxRegion] ?? null;
  }

  get isExistedTaxRegion() {
    if (this.taxRegion === this.defaultRegion) return true;

    return !!this.state.customFinData[this.taxRegion];
  }

  renderCustomFinDataSection() {
    if (!this.isExistedTaxRegion)
      return (
        <HBox gap="16px" style={{ marginTop: '24px' }}>
          <p>{this.lbl('product.create.taxRegionDefaultMsg')}</p>
          <ButtonComponent style={'ButtonSoftEdit'} onClick={this.onClickAddRegion.bind(this)}>
            {this.lbl('product.create.addtaxRegionBtn')}
          </ButtonComponent>
        </HBox>
      );

    return (
      <ProductCustomFinDataSection
        ledgers={this.ledgers}
        vatCodes={this.vatCodes}
        data={this.getCustomDataForTaxRegion(this.taxRegion)}
        onFieldChanged={this.onCustomFieldChanged.bind(this)}
      />
    );
  }

  renderAddTaxRegionModal() {
    if (!this.state.showAddTaxRegionModal) return '';

    return (
      <ModalComponent
        onClose={() => this.setState({ showAddTaxRegionModal: false })}
        title={this.lbl('product.create.taxRegionSelectionModalTitle')}
      >
        <ModalContentWrapper>
          <SearchSelect
            options={this.availableNewTaxRegionOptions}
            value={{ label: this.state.selectedNewTaxRegion }}
            onChange={this.setSelectedNewTaxRegion}
          />
        </ModalContentWrapper>
        <div className="d-flex gap-2 mt-2 justify-content-end">
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            disabled={!this.state.selectedNewTaxRegion}
            onClick={this.addTaxRegion.bind(this)}
          >
            {this.lbl('ok')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={() => this.setState({ showAddTaxRegionModal: false })}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  onClickAddRegion() {
    this.setState({ showAddTaxRegionModal: true });
  }

  addTaxRegion() {
    const dto = this.getCustomDataForTaxRegion(this.defaultRegion);
    dto.taxRegion = this.state.selectedNewTaxRegion;
    dto.dirty = true;
    this.setState(state => ({
      customFinData: { ...state.customFinData, [dto.taxRegion]: dto },
      taxRegion: dto.taxRegion,
      showAddTaxRegionModal: false,
    }));
  }

  render() {
    if (this.props.work) {
      return <Loader small />;
    }

    return (
      <Container>
        <PageHeader
          title={
            <div onClick={this.reset.bind(this)}>
              <Left />
              {this.lbl('product.overview.title')}
            </div>
          }
          breadCrumbs={
            <HBox right vCenter>
              <span className="nav-link" onClick={() => this.to('/')}>
                Vindat
              </span>
              <ChevronRight />
              <span className="nav-link" onClick={() => this.to('/products')}>
                {this.lbl('product.overview.title')}
              </span>

              <ChevronRight />
              <span className="nav-link active" onClick={() => this.to('/products/create')}>
                {this.props.id ? this.lbl('product.edit.title') : this.lbl('product.create.title')}
              </span>
            </HBox>
          }
        />

        <div className="info-card">
          <Content>
            <Wrapper>
              <VBox left className="col col-main">
                <h2>{this.props.id ? this.lbl('product.edit.title') : this.lbl('product.create.title')}</h2>
                <HBox left className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.name')}</label>
                    <input
                      name="name"
                      className="form-control"
                      value={this.state.name}
                      onChange={event => {
                        this.onStringInputChange(event);
                        this.onStringInputChange1(event);
                      }}
                    />
                  </div>
                </HBox>
                <HBox className="field-block">
                  <div className={styles.inputContainer}>
                    <label className="form-label">{this.lbl('product.create.description')}</label>
                    <textarea
                      style={{
                        width: '100%',
                      }}
                      className="form-control"
                      name="description"
                      value={this.state.description}
                      onChange={this.onStringInputChange.bind(this)}
                    />
                  </div>
                </HBox>

                <HBox className="field-block">
                  <FormField label={this.lbl('product.create.status')}>
                    <SearchSelect
                      minWidth="100%"
                      options={this.statusOption}
                      value={this.state.status && { label: this.lbl(`product.column.status.${this.state.status}`) }}
                      onChange={this.setStatus}
                    />
                  </FormField>
                </HBox>

                <HBox gap="16px" style={{ marginTop: '24px' }}>
                  <VBox left>
                    <h2>{this.lbl('product.create.col.buyier')}</h2>

                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.purchase_price_excl_vat')}</label>
                      <input
                        name="purchasePriceExclVat"
                        className="form-control"
                        value={limitToTwoDecimalPlaces(this.state.purchasePriceExclVatToShow)}
                        type="text"
                        onChange={this.onNumberInputChange.bind(this)}
                      />
                    </div>
                  </VBox>

                  <VBox left>
                    <h2>{this.lbl('product.create.col.seller')}</h2>

                    <div className={styles.inputContainer}>
                      <label className="form-label">{this.lbl('product.create.sales_price_excl_vat')}</label>
                      <input
                        name="salesPriceExclVat"
                        className="form-control"
                        // value={limitToTwoDecimalPlaces(this.state.salesPriceExclVat)}
                        value={limitToTwoDecimalPlaces(this.state.salesPriceExclVatToShow)}
                        type="text"
                        onChange={this.onNumberInputChange.bind(this)}
                      />
                    </div>
                  </VBox>
                </HBox>
                <HBox gap="16px" style={{ marginTop: '24px' }}>
                  <VBox left>
                    <HBox className="field-block">
                      <FormField label={this.lbl('product.create.tax_region')}></FormField>
                    </HBox>
                  </VBox>
                </HBox>
                {this.availableNewTaxRegionOptions.length ? (
                  <HBox gap="16px" style={{ marginTop: '24px' }}>
                    <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.onClickAddRegion.bind(this)}>
                      {this.lbl('product.create.addtaxRegionBtn')}
                    </ButtonComponent>
                  </HBox>
                ) : (
                  ''
                )}
                {this.renderAddTaxRegionModal()}
                <TaxRegionsTab
                  activeRegion={this.taxRegion}
                  addedRegions={this.addedRegions}
                  onClickTaxRegion={this.setTaxRegion}
                />
                {this.renderCustomFinDataSection()}
                {env.wientjes_installation || env.autohuis_salland_installation ? (
                  ''
                ) : (
                  <FormField label={this.lbl('product.create.companyField')}>
                    <CompanySpecificField product={this.product} vatCodes={this.vatCodes} />
                  </FormField>
                )}
                {this.props.id && <ProductTasksSection product_id={this.props.id} />}
              </VBox>
              <VBox left className="col col-main">
                <h2>{this.lbl('product.create.characteristics')}</h2>
                {[AppClientId.HOOIKAMMER, AppClientId.AUTOWIENTJES, AppClientId.AUTOHUISSALLAND].includes(env.clientId) ? (
                  ''
                ) : (
                  <HBox left className="field-block">
                    <FormField label={this.lbl('product.create.vehicle_purpose_type')}>
                      <SearchSelect
                        minWidth="100%"
                        options={this.vehiclePurposeOptions()}
                        value={this.state.vehiclePurposeType && { label: this.state.vehiclePurposeType }}
                        onChange={this.setVehiclePurposeType}
                      />
                    </FormField>
                  </HBox>
                )}

                <CheckboxComponent
                  label={this.lbl('product.create.is_one_time')}
                  checked={this.state.isOneTime == '1'}
                  onChange={() => {
                    const value = this.state.isOneTime == '1' ? '0' : '1';
                    return this.setIsOneTime(value);
                  }}
                ></CheckboxComponent>

                {env.wientjes_installation || env.autohuis_salland_installation ? (
                  ''
                ) : (
                  <>
                    <CheckboxComponent
                      label={this.lbl('product.create.is_counter')}
                      checked={this.state.isCounter == '1'}
                      onChange={() => {
                        const value = this.state.isCounter == '1' ? '0' : '1';
                        return this.setIsCounter(value);
                      }}
                    ></CheckboxComponent>

                    <HBox left className="field-block">
                      <FormField>
                        <SearchSelect
                          minWidth="100%"
                          isLoading={this.props.workCounters}
                          options={this.counterOptions}
                          value={this.state.counter && { label: this.state.counter }}
                          onChange={this.setVehicleCounter}
                        />
                      </FormField>
                    </HBox>
                  </>
                )}
                {env.wientjes_installation || env.autohuis_salland_installation ? (
                  ''
                ) : (
                  <CheckboxComponent
                    label={this.lbl('product.create.is_transport')}
                    checked={this.state.isTransport == '1'}
                    onChange={() => {
                      const value = this.state.isTransport == '1' ? '0' : '1';
                      return this.setIsTransport(value);
                    }}
                  ></CheckboxComponent>
                )}
              </VBox>
            </Wrapper>
            <div className="d-flex gap-2 mt-2 justify-content-end">
              <ButtonComponent style="ButtonSoftDelete" select onClick={this.reset.bind(this)}>
                {this.lbl('product.create.reset')}
              </ButtonComponent>
              {env.clientId == AppClientId.HILTERMANN ? (
                <ButtonComponent style="ButtonSoftPrimary" onClick={this.onComplete.bind(this)}>
                  {this.saveButtonLabel}
                </ButtonComponent>
              ) : (
                <ButtonComponent
                  style="ButtonSoftPrimary"
                  disabled={this.completeDisabled || this.state.saveDisable}
                  onClick={this.onComplete.bind(this)}
                >
                  {this.saveButtonLabel}
                </ButtonComponent>
              )}
            </div>
          </Content>
        </div>
      </Container>
    );
  }
}

ProductCreateComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    fetchedCompany: selectCompany(),
    vatCodes: selectVatCodes(),
    ledgers: selectLedgers(),
    counters: selectVehicleCounters(),
    work: selectWorks([REQUEST_VAT_CODES, REQUEST_LEDGERS, REQUEST_UPDATE_PRODUCT, REQUEST_CREATE_PRODUCT_CUSTOM_FIN_DATA]),
    workCounters: selectWork(REQUEST_GET_COUNTERS),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewProductValue(name, value));
    },
    fetch: callback => {
      dispatch(fetchProduct(ownProps.id, callback));
    },
    getCounters(callback) {
      dispatch(getCounters(callback));
    },
    create(dto, callback) {
      dispatch(createProduct(dto, callback));
    },
    update(dto, callback) {
      dispatch(updateProduct(ownProps.id, dto, callback));
    },
    getVatCodes() {
      dispatch(getVatCodes());
    },
    getLedgers() {
      dispatch(getLedgers());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductCreate = compose(withConnect, withRouter)(ProductCreateComp);
